import(/* webpackMode: "eager" */ "/home/clients/2dddb5af0e226b301eba330a745cb36f/web/invento/src/app/not-found.tsx");
